var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5312 12.625H14.4375C13.8682 12.625 13.4062 12.164 13.4062 11.5938C13.4062 11.0235 13.8682 10.5625 14.4375 10.5625H17.5312C19.8062 10.5625 21.6562 8.71244 21.6562 6.4375C21.6562 4.16256 19.8062 2.3125 17.5312 2.3125H6.1875C3.91256 2.3125 2.0625 4.16256 2.0625 6.4375C2.0625 8.71244 3.91256 10.5625 6.1875 10.5625C6.75675 10.5625 7.21875 11.0235 7.21875 11.5938C7.21875 12.164 6.75675 12.625 6.1875 12.625C2.77509 12.625 0 9.84991 0 6.4375C0 3.02509 2.77509 0.25 6.1875 0.25H17.5312C20.9437 0.25 23.7188 3.02509 23.7188 6.4375C23.7188 9.84991 20.9437 12.625 17.5312 12.625ZM26.8125 17.7812H15.4688C12.0563 17.7812 9.28125 15.0062 9.28125 11.5938C9.28125 8.18134 12.0563 5.40625 15.4688 5.40625H18.5625C19.1328 5.40625 19.5938 5.86825 19.5938 6.4375C19.5938 7.00675 19.1328 7.46875 18.5625 7.46875H15.4688C13.1938 7.46875 11.3438 9.31881 11.3438 11.5938C11.3438 13.8687 13.1938 15.7188 15.4688 15.7188H26.8125C29.0874 15.7188 30.9375 13.8687 30.9375 11.5938C30.9375 9.31881 29.0874 7.46875 26.8125 7.46875C26.2422 7.46875 25.7812 7.00675 25.7812 6.4375C25.7812 5.86825 26.2422 5.40625 26.8125 5.40625C30.2249 5.40625 33 8.18134 33 11.5938C33 15.0062 30.2249 17.7812 26.8125 17.7812Z",
    fill: "#D6DCE8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5312 12.625H14.4375C13.8682 12.625 13.4062 12.164 13.4062 11.5938C13.4062 11.0235 13.8682 10.5625 14.4375 10.5625H17.5312C19.8062 10.5625 21.6562 8.71244 21.6562 6.4375C21.6562 4.16256 19.8062 2.3125 17.5312 2.3125H6.1875C3.91256 2.3125 2.0625 4.16256 2.0625 6.4375C2.0625 8.71244 3.91256 10.5625 6.1875 10.5625C6.75675 10.5625 7.21875 11.0235 7.21875 11.5938C7.21875 12.164 6.75675 12.625 6.1875 12.625C2.77509 12.625 0 9.84991 0 6.4375C0 3.02509 2.77509 0.25 6.1875 0.25H17.5312C20.9437 0.25 23.7188 3.02509 23.7188 6.4375C23.7188 9.84991 20.9437 12.625 17.5312 12.625ZM26.8125 17.7812H15.4688C12.0563 17.7812 9.28125 15.0062 9.28125 11.5938C9.28125 8.18134 12.0563 5.40625 15.4688 5.40625H18.5625C19.1328 5.40625 19.5938 5.86825 19.5938 6.4375C19.5938 7.00675 19.1328 7.46875 18.5625 7.46875H15.4688C13.1938 7.46875 11.3438 9.31881 11.3438 11.5938C11.3438 13.8687 13.1938 15.7188 15.4688 15.7188H26.8125C29.0874 15.7188 30.9375 13.8687 30.9375 11.5938C30.9375 9.31881 29.0874 7.46875 26.8125 7.46875C26.2422 7.46875 25.7812 7.00675 25.7812 6.4375C25.7812 5.86825 26.2422 5.40625 26.8125 5.40625C30.2249 5.40625 33 8.18134 33 11.5938C33 15.0062 30.2249 17.7812 26.8125 17.7812Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.13196,
    y: -10.0625,
    width: 37.125,
    height: 37.125,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.41daf27f3c75455268f10a09dd561c17.svg";
export { ForwardRef as ReactComponent };